<template>
  <div class="order">
    <van-tabs
      v-model="active"
      color="#47d3ff"
      line-width="2rem"
      title-active-color="#47d3ff"
      swipe-threshold="3"
      :sticky="true"
      @click="getTab"
    >
      <van-tab :title="k.name" v-for="(k, j) in statusList" :key="j">
        <template v-if="active == j">
          <load-list :interFace="interFace">
            <template v-slot:list="props">
              <div
                v-for="(item, index) in props.list"
                :key="index"
                class="list"
                @click="toDetail(item.id)"
              >
                <van-swipe-cell>
                  <div class="list-cell">
                    <div class="list-left">
                      <img :src="$IMG_PATH + item.img[0]" alt="" />
                      <!-- <img :src="item.img" alt="" /> -->
                    </div>
                    <div class="list-right">
                      <div class="cate-name">
                        <span>督查点位：</span>{{ item.point_name }}
                      </div>
                      <div class="cate-name">
                        <span>考察内容：</span>{{ item.cate_name }}
                      </div>
                      <div class="cate-name">
                        <span>地址：{{ item.address }}</span>
                      </div>
                      <div class="cate-name">
                        <span>归属：</span>{{ item.area_name }}
                      </div>
                      <div class="sta">
                        <span
                          class="sta-0"
                          v-for="(c, i) in item.tags"
                          :key="i"
                        >
                          {{ c }}</span
                        >
                      </div>

                      <span style="color: #999; font-size: 0.24rem">{{
                        item.add_time_text
                      }}</span>
                    </div>
                  </div>
                  <template #right v-if="k.status !== 4">
                    <van-button
                      square
                      type="danger"
                      :text="
                        k.status == 5
                          ? '拒退'
                          : k.status == 2 && item.unqualified_num == 0
                          ? '一次不合格'
                          : '二次不合格'
                      "
                      class="btn-left"
                      @click="delate(item.id, k.status, item.unqualified_num)"
                      v-if="k.status !== 1 && item.unqualified_num !== 2"
                    />
                    <van-button
                      square
                      type="primary"
                      text="重新指派"
                      class="btn-right"
                      @click="deal(item.id, k.status)"
                      v-if="k.status !== 1 && k.status == 5"
                    />
                    <van-button
                      square
                      type="primary"
                      text="结案"
                      class="btn-right-1"
                      @click="delate2(item.id)"
                    />
                  </template>
                </van-swipe-cell>
              </div>
            </template>
          </load-list>
        </template>
      </van-tab>
    </van-tabs>
    <van-dialog
      v-model="showAlert"
      :title="textReason"
      show-cancel-button
      @confirm="subDel"
    >
      <van-field
        v-model="message"
        rows="2"
        autosize
        type="textarea"
        maxlength="100"
        placeholder="请输入理由"
        show-word-limit
      />
    </van-dialog>
    <van-dialog
      v-model="showFinish"
      title="结案理由"
      show-cancel-button
      @confirm="subDel2"
    >
      <van-field
        v-model="message"
        rows="2"
        autosize
        type="textarea"
        maxlength="100"
        placeholder="请输入结案理由"
        show-word-limit
      />
    </van-dialog>
    <van-dialog
      v-model="assignShow"
      title="重新指派"
      show-cancel-button
      @confirm="assignTo"
    >
      <div class="all">
        <div class="item-all" @click="branchShow = true">
          <span>{{ branch ? branch : "请选择责任部门" }}</span>

          <img src="@/assets/images/report/choose.png" alt="" class="img-con" />
        </div>
      </div>
    </van-dialog>
    <van-popup v-model="branchShow" round position="bottom">
      <van-picker
        title="选择责任部门"
        show-toolbar
        :columns="columns"
        @confirm="getBranch"
        @cancel="branchShow = false"
      />
    </van-popup>
  </div>
</template>

<script>
import LoadList from "@/components/SearchLoadList";
import { getInspectorList, changeWork, getAreaList, assignNew } from "../api";
import { Dialog } from "vant";
import { Toast } from "vant";
export default {
  components: {
    LoadList,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      interFace: {
        api: getInspectorList,
        params: {
          status: 1,
        },
      },
      active: 0,
      textReason: "",
      statusList: [
        { status: 1, name: "已指派" },
        { status: 5, name: "已退回" },
        { status: 2, name: "已反馈" },
        { status: 3, name: "整改不合格" },
        { status: 4, name: "整改合格" },
      ],
      showAlert: false,
      showFinish: false,
      delateId: "",
      status: "",
      text: "",
      assignShow: false,
      columns: [],
      columnsId: [],
      branch: "",
      branch_id: "",
      branchShow: false,
      message: "",
    };
  },
  created() {
    this.initCol();
  },
  methods: {
    subDel() {
      if (!this.message) {
        Toast.fail("请输入理由");
      } else {
        let that = this;
        this.showAlert = false;
        Toast.loading("提交中");
        let type =
          this.status == 5 ? 3 : this.status == 2 && this.text == 0 ? 4 : 6;
        console.log(type);
        let params = {
          type:
            this.status == 5 ? 3 : this.status == 2 && this.text == 0 ? 4 : 6,
          id: this.delateId,
          content: this.message,
          token: window.localStorage.getItem("token"),
        };
        changeWork(params).then((res) => {
          console.log("res", res);
          if (res.code == 0) {
            Toast.success("拒退成功");
            setTimeout(() => {
              that.$router.go(0);
            }, 1200);
          }
          this.message = "";
          this.delateId = "";
        });
      }
    },
    subDel2() {
      if (!this.message) {
        Toast.fail("请输入理由");
      } else {
        let that = this;
        this.showFinish = false;
        Toast.loading("提交中");
        let params = {
          type: 5,
          id: this.delateId,
          content: this.message,
          token: window.localStorage.getItem("token"),
        };
        changeWork(params).then((res) => {
          console.log("res", res);
          if (res.code == 0) {
            Toast.success("提交成功");
            setTimeout(() => {
              that.$router.go(0);
            }, 1200);
          }
          this.message = "";
          this.delateId = "";
        });
      }
    },
    delate(id, status, text) {
      this.showAlert = true;
      this.delateId = id;
      this.status = status;
      this.text = text;
      this.textReason = "操作理由";
    },
    delate2(id) {
      this.showFinish = true;
      this.delateId = id;
    },
    getTab(name, title) {
      console.log(name, title);
      this.$set(this.interFace.params, "status", this.statusList[name].status);
    },
    toDetail(id) {
      this.$router.push({
        name: "orderDetail",
        params: {
          id: id,
        },
      });
    },
    deal(id, status) {
      this.delateId = id;
      this.status = status;
      if (status == 5) {
        this.assignShow = true;
      }
    },

    assignTo() {
      let params = {
        id: this.delateId,
        area_id: this.branch_id,
      };
      assignNew(params).then((res) => {
        if (res.code == 0) {
          Toast.success("指派成功");
          setTimeout(() => {
            this.$router.go(0);
          }, 1000);
        }
      });
    },
    getBranch(value, index) {
      this.branchShow = false;
      this.branch = value;
      this.branch_id = this.columnsId[index];
    },
    initCol() {
      let params = {
        id: 877,
      };
      getAreaList(params).then((res) => {
        this.columns = res.data.items.map((e) => {
          return e.title;
        });
        this.columnsId = res.data.items.map((e) => {
          return e.id;
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.order {
  width: 100%;
  /deep/ .van-tab {
    width: 30%;
  }
  .list {
    width: calc(100% - 0.3rem);
    height: 3rem;
    margin: 0 auto;
    padding: 0.2rem 0.28rem 0;
    background-color: #fff;
    display: flex;
    margin-top: 0.3rem;
    border-radius: 0.16rem;
    .list-cell {
      width: 100%;
      height: 2.3rem;
      background-color: #fff;
      display: flex;
      .list-left {
        width: 2.82rem;
        height: 1.92rem;
        img {
          width: 100%;
          height: 100%;
          margin-top: 0.2rem;
          border-radius: 0.12rem;
        }
      }
      .list-right {
        width: calc(100% - 2.82rem);
        height: 2.7rem;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        padding-left: 0.5rem;
        color: #333333;
        font-size: 0.26rem;
        .cate-name {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #78c0ff;
          span {
            color: #333;
          }
        }

        .sta {
          height: 0.44rem;
          display: flex;
          > span:first-child {
            margin-left: 0;
          }
          .sta-0 {
            max-width: 1.4rem;
            text-align: center;
            display: block;
            background-color: #fba738;
            color: #fff;
            font-size: 0.22rem;
            padding: 0.04rem;
            margin-left: 0.1rem;
          }
        }

        .sta-1 {
          width: 1.4rem;
          text-align: center;
          display: block;
          background-color: #fba738;
          color: #fff;
          font-size: 0.22rem;
          padding: 0.04rem 0;
        }
      }
    }
    .btn-left {
      height: 100%;
      line-height: 2.3rem;
      border: none;
      background-color: #fdae5a;
    }
    .btn-right {
      height: 100%;
      line-height: 2.3rem;
      border: none;
      background-color: #3b95fc;
    }
    .btn-right-1 {
      height: 100%;
      line-height: 2.3rem;
      border: none;
      background-color: #b9b87d;
    }
  }
  .all {
    width: 100%;
    min-height: 0.84rem;
    margin-bottom: 0.2rem;
    .item-all {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 0.84rem;
      border: 0px solid rgba(225, 225, 225, 1);
      border-radius: 0.15rem;
      color: #333;
      background: rgba(245, 245, 245, 1);
      border: 0px solid rgba(225, 225, 225, 1);
      border-radius: 4px;
      color: #666666;
      font-size: 14px;
      padding: 0 0.3rem;
      .img-con {
        width: 0.3rem;
        height: 0.3rem;
      }
    }
  }
}
</style>